<template>
    <div id="content">
        <Blog v-if="selected_tab=='1'"/>
        <Works v-if="selected_tab=='2'"/>
        <ArtWorks v-if="selected_tab=='6'"/>
        <Experience v-if="selected_tab=='3'"/>
        <About v-if="selected_tab=='4'"/>
        <Contact v-if="selected_tab=='5'"/>
    </div>
</template>

<script>
import Works from './Works.vue'
import Experience from './Experience.vue'
import About from './About.vue'
import Contact from './Contact.vue'
import Blog from './Blog.vue'
import ArtWorks from './ArtWorks.vue'

export default {
    name: 'Content',
    components: {
        Blog,
        Works,
        ArtWorks,
        Experience,
        About,
        Contact
    },
    props: ["selected_tab"]
}
</script>

<style>
#content{
    flex: 1;
    padding-top: 152px;
    padding-left: 40px;
    padding-right: 20px;
    padding-bottom: 40px;
}

@media screen and (max-width: 600px){
    #content{
        padding-top: 20px;
        text-align: center;
    }
    .heading{
        width: 100%;
        text-align: center;
    }
}

.heading{
    font-size: 28px;
}
.section{
    font-size: 24px;
}
.para{
    font-size: 16px;
}
</style>